<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @submit="onLogin">
                  <h1>{{ t('login_header') }}</h1>
                  <p class="text-muted">{{ t('login_description') }}</p>
                  <b-alert class="text-center" variant="danger" show v-if="form.login.alert.danger">{{form.login.alert.danger}} <strong v-if="form.login.alert.resend" @click="onResend()" style="cursor: pointer;">{{t('login_resend')}}</strong></b-alert>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text>@</b-input-group-text></b-input-group-prepend>
                    <b-form-input type="email" v-model="form.login.email" class="form-control" :placeholder="t('global_email')" autocomplete="username email" />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" v-model="form.login.password" class="form-control" :placeholder="t('global_password')" autocomplete="current-password" />
                  </b-input-group>
                  <b-row>
                    <b-col cols="8" offset="2" class="text-center">
                      <b-button variant="primary" block class="px-4" @click="onLogin" :disabled="form.login.locked">{{ t('login_button') }}</b-button>
                      <br>
                      <b-link variant="primary" class="active mt-3" to="/auth/remember">{{ t('login_password_remember') }}</b-link>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card no-body class="text-white bg-primary py-5" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <h2>{{ t('login_right_header') }}</h2>
                  <p>{{ t('login_right_content') }}</p>
                  <b-button variant="primary" class="active mt-3" to="/auth/register">{{ t('login_right_button') }}</b-button>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "Login",
  data() {
    return {
      form: {
        login: {
          email: "",
          password: "",
          alert: {
            danger: "",
            resend: false
          },
          locked: false
        }
      }
    };
  },
  methods: {
    onResend() {
      Vue.axios({
        method: "POST",
        url: "/user/resend",
        data: {
          email: this.form.login.email
        },
        mode: "no-cors",
        withCredentials: true,
        credentials: "same-origin"
      })
        .then(response => {
          if (response.data.status) {
            Vue.swal(this.$translate.text("login_resent"), "", "success");
            this.form.login.alert.danger = "";
          } else {
            this.form.login.alert.danger = response.data.message
              ? this.$translate.text(response.data.message)
              : this.$translate.text("global_an-unexpected-error-occurred");
          }
        })
        .catch(() => {
          this.form.login.alert.danger = this.$translate.text(
            "global_an-unexpected-error-occurred"
          );
        });
    },
    onLogin() {
      if (this.form.login.locked) return;

      this.form.login.alert.danger = "";
      this.form.login.alert.resend = false;

      const email = this.form.login.email.trim();
      const password = this.form.login.password.trim();

      if (email === "" || password === "") {
        this.form.login.alert.danger = this.$translate.text(
          "login_please-enter-your-credentials"
        );
      } else {
        this.form.login.locked = true;

        Vue.axios({
          method: "POST",
          url: "/user/login",
          data: {
            email: this.form.login.email,
            password: this.form.login.password
          },
          mode: "no-cors",
          withCredentials: true,
          credentials: "same-origin"
        })
          .then(response => {
            if (response.data.status) {
              this.$router.push({ name: "Dashboard" });
              this.$store.state.isLogged = true;
              this.$store.state.isAdmin = response.data.isAdmin;
            } else {
              this.form.login.alert.danger = response.data.message
                ? this.$translate.text(response.data.message)
                : this.$translate.text("global_an-unexpected-error-occurred");

              if (response.data.message === "login_please-confirm-your-email") {
                this.form.login.alert.resend = true;
              }

              this.form.login.locked = false;
            }
          })
          .catch(() => {
            this.form.login.alert.danger = this.$translate.text(
              "global_an-unexpected-error-occurred"
            );
            this.form.login.locked = false;
          });
      }
    }
  }
};
</script>
